export default {
  meta: {
    title: '销售日报',
    url: '/abside/daily', // 埋点字段，上报归属的模块
    urlName: 'ab侧-销售日报', // 埋点字段，上报归属的模块
    logincallback: '/abside',
  }
};
